export enum StateKey {
  HasBalance = 'hasBalance',
  RichInbox = 'richinbox',
  IsNativeApp = 'isNativeApp',
  Nonce = 'nonce',
}

export const clearSensitiveSessionStorage = () => {
  if (import.meta.client) {
    sessionStorage.removeItem(StateKey.RichInbox)
  }
}
